export { ReactComponent as IcStarDone16 } from 'assets/16/star_done_16.svg';
export { ReactComponent as IcChevron16 } from 'assets/16/chevron_16.svg';
export { ReactComponent as IcClose16 } from 'assets/16/close_16.svg';
export { ReactComponent as IcDropdown16 } from 'assets/16/dropdown_16.svg';
export { ReactComponent as IcStatusSending16 } from 'assets/16/status_sending_16.svg';
export { ReactComponent as IcStatusSent16 } from 'assets/16/status_sent_16.svg';
export { ReactComponent as IcStatusRead16 } from 'assets/16/status_read_16.svg';
export { ReactComponent as IcVerified16 } from 'assets/16/ic-badge-verified-28.svg';
export { ReactComponent as IcSnowflake16 } from 'assets/16/snowflake-16.svg';
export { ReactComponent as IcTelegram16 } from 'assets/16/telegram.svg';
export { ReactComponent as IcAngleRight16 } from 'assets/16/angle_right_16.svg';
export { ReactComponent as IcAngleUp16 } from 'assets/16/angle_up_16.svg';
export { ReactComponent as IcCheck16 } from 'assets/16/check_16.svg';
export { ReactComponent as IcAngleDownFill16 } from 'assets/16/angle-down-fill.svg';

export { ReactComponent as IcMore20 } from 'assets/20/more_20.svg';
export { ReactComponent as IcHide20 } from 'assets/20/hide_20.svg';
export { ReactComponent as IcView20 } from 'assets/20/view_20.svg';
export { ReactComponent as IcCopy20 } from 'assets/20/copy_20.svg';

export { ReactComponent as IcDiamond22 } from 'assets/22/diamond_22.svg';
export { ReactComponent as IcAddStory22 } from 'assets/22/add_story_22.svg';

export { ReactComponent as IcLike24 } from 'assets/24/like_24.svg';
export { ReactComponent as IcShare24 } from 'assets/24/share_24.svg';
export { ReactComponent as IcViews24 } from 'assets/24/views_24.svg';
export { ReactComponent as IcMore24 } from 'assets/24/more_24.svg';
export { ReactComponent as IcComment24 } from 'assets/24/comment_24.svg';
export { ReactComponent as IcCheckbox24 } from 'assets/24/checkbox_24.svg';
export { ReactComponent as IcRadioButton24 } from 'assets/24/radio_button_24.svg';
export { ReactComponent as IcRadioButtonEmpty24 } from 'assets/24/radio_button_empty_24.svg';
export { ReactComponent as IcFullscreen24 } from 'assets/24/fullscreen_24.svg';
export { ReactComponent as IcFullscreenExit24 } from 'assets/24/fullscreen_exit_24.svg';
export { ReactComponent as IcPin24 } from 'assets/24/pin_24.svg';
export { ReactComponent as IcHome24 } from 'assets/24/home_24.svg';
export { ReactComponent as IcUsers24 } from 'assets/24/users_24.svg';
export { ReactComponent as IcTransactions24 } from 'assets/24/transactions_24.svg';
export { ReactComponent as IcReport24 } from 'assets/24/report_24.svg';
export { ReactComponent as IcBurger24 } from 'assets/24/burger_24.svg';
export { ReactComponent as IcPayouts24 } from 'assets/24/payouts_24.svg';
export { ReactComponent as IcBubble24 } from 'assets/24/bubble_24.svg';
export { ReactComponent as IcBell24 } from 'assets/24/bell_24.svg';
export { ReactComponent as IcSearch24 } from 'assets/24/search_24.svg';
export { ReactComponent as IcTelegram24 } from 'assets/24/telegram_24.svg';
export { ReactComponent as IcDollar24 } from 'assets/24/dollar_24.svg';
export { ReactComponent as IcGlobe24 } from 'assets/24/globe_24.svg';
export { ReactComponent as IcDelete24 } from 'assets/24/delete_24.svg';
export { ReactComponent as IcSoundOff24 } from 'assets/24/sound_off_24.svg';
export { ReactComponent as IcSoundOn24 } from 'assets/24/sound_on_24.svg';
export { ReactComponent as IcClips24 } from 'assets/24/clips_24.svg';
export { ReactComponent as IcDashboard24 } from 'assets/24/dashboard_24.svg';
export { ReactComponent as IcBundle24 } from 'assets/24/bundle_24.svg';

export { ReactComponent as IcNewYearSearch24 } from 'assets/24/newyear-search_24.svg';
export { ReactComponent as IcNewYearBell24 } from 'assets/24/newyear-bell_24.svg';
export { ReactComponent as IcNewYearBubble24 } from 'assets/24/newyear-bubble_24.svg';
export { ReactComponent as IcNewYearHome24 } from 'assets/24/newyear-home_24.svg';
export { ReactComponent as IcNewYearBurger24 } from 'assets/24/newyear-burger_24.svg';
export { ReactComponent as IcNewYearClips24 } from 'assets/24/newyear-clips_24.svg';
export { ReactComponent as IcNewYearDashboard24 } from 'assets/24/newyear-dashboard_24.svg';
export { ReactComponent as IcApple24 } from 'assets/24/apple_24.svg';
export { ReactComponent as IcGoogle24 } from 'assets/24/google_24.svg';
export { ReactComponent as IcPaypal24 } from 'assets/24/paypal_24.svg';

export { ReactComponent as IcArrowDownCircle28 } from 'assets/28/arrow_down_circle_28.svg';
export { ReactComponent as IcArrowUpCircle28 } from 'assets/28/arrow_up_circle_28.svg';
export { ReactComponent as IcPremium28 } from 'assets/28/premium_28.svg';
export { ReactComponent as IcFullscreen28 } from 'assets/28/fullscreen.svg';
export { ReactComponent as IcGift28 } from 'assets/28/gift_28.svg';
export { ReactComponent as IcStarDone28 } from 'assets/28/star_done_28.svg';
export { ReactComponent as IcStar28 } from 'assets/28/star_28.svg';
export { ReactComponent as IcHome28 } from 'assets/28/home_28.svg';
export { ReactComponent as IcDiscover28 } from 'assets/28/discover_28.svg';
export { ReactComponent as IcMessage28 } from 'assets/28/message_28.svg';
export { ReactComponent as IcNotifications28 } from 'assets/28/notifications_28.svg';
export { ReactComponent as IcMenu28 } from 'assets/28/menu_28.svg';
export { ReactComponent as IcBack28 } from 'assets/28/back_28.svg';
export { ReactComponent as IcClose28 } from 'assets/28/close_28.svg';
export { ReactComponent as IcPhone28 } from 'assets/28/phone_28.svg';
export { ReactComponent as IcMic28 } from 'assets/28/mic_28.svg';
export { ReactComponent as IcMicOff28 } from 'assets/28/mic_off_28.svg';
export { ReactComponent as IcCam28 } from 'assets/28/cam_28.svg';
export { ReactComponent as IcCamOff28 } from 'assets/28/cam_off_28.svg';
export { ReactComponent as IcGallery28 } from 'assets/28/gallery_28.svg';
export { ReactComponent as IcVideo28 } from 'assets/28/video_28.svg';
export { ReactComponent as IcSend28 } from 'assets/28/send_28.svg';
export { ReactComponent as IcFilters28 } from 'assets/28/filters_28.svg';
export { ReactComponent as IcUser28 } from 'assets/28/user_28.svg';
export { ReactComponent as IcAdd28 } from 'assets/28/add_28.svg';
export { ReactComponent as IcAddCircle28 } from 'assets/28/add_circle_28.svg';
export { ReactComponent as IcDone28 } from 'assets/28/done_28.svg';
export { ReactComponent as IcEdit28 } from 'assets/28/edit_28.svg';
export { ReactComponent as IcPlus28 } from 'assets/28/plus_28.svg';
export { ReactComponent as IcSignOut28 } from 'assets/28/signout_28.svg';
export { ReactComponent as IcUserPlus28 } from 'assets/28/user_plus_28.svg';
export { ReactComponent as IcUsers28 } from 'assets/28/users_28.svg';
export { ReactComponent as IcSearch28 } from 'assets/28/search_28.svg';
export { ReactComponent as IcError28 } from 'assets/28/error_28.svg';
export { ReactComponent as IcWrite28 } from 'assets/28/write_28.svg';
export { ReactComponent as IcPlay28 } from 'assets/28/play_28.svg';
export { ReactComponent as IcCopy28 } from 'assets/28/copy_28.svg';
export { ReactComponent as IcSettings28 } from 'assets/28/settings_28.svg';
export { ReactComponent as IcList28 } from 'assets/28/list_28.svg';
export { ReactComponent as IcIncognito28 } from 'assets/28/incognito_28.svg';

export { ReactComponent as IcKey28 } from 'assets/28/key_28.svg';
export { ReactComponent as IcBalance28 } from 'assets/28/balance_28.svg';
export { ReactComponent as IcDollar28 } from 'assets/28/dollar_28.svg';
export { ReactComponent as IcContest28 } from 'assets/28/contest_28.svg';
export { ReactComponent as IcMonetization28 } from 'assets/28/monetization_28.svg';
export { ReactComponent as IcBanOff28 } from 'assets/28/ban_off_28.svg';
export { ReactComponent as IcHot28 } from 'assets/28/hot_28.svg';
export { ReactComponent as IcCircle28 } from 'assets/28/circle_28.svg';
export { ReactComponent as IcBlockedCountries28 } from 'assets/28/blocked_countries_28.svg';
export { ReactComponent as IcInfo28 } from 'assets/28/info_28.svg';
export { ReactComponent as IcFolder28 } from 'assets/28/folder_28.svg';
export { ReactComponent as IcSupport28 } from 'assets/28/support_28.svg';
export { ReactComponent as IcSwitch28 } from 'assets/28/switch_28.svg';
export { ReactComponent as IcUserSponsor28 } from 'assets/28/user_sponsor_28.svg';
export { ReactComponent as IcPlusCircle28 } from 'assets/28/plus_circle_28.svg';
export { ReactComponent as IcChart28 } from 'assets/28/chart_28.svg';
export { ReactComponent as IcWheel28 } from 'assets/28/wheel_28.svg';
export { ReactComponent as IcAngleLeft28 } from 'assets/28/angle_left_28.svg';
export { ReactComponent as IcAngleRight28 } from 'assets/28/angle_right_28.svg';
export { ReactComponent as IcUpload28 } from 'assets/28/upload_28.svg';
export { ReactComponent as IcSocialBoosty28 } from 'assets/28/social-boosty_28.svg';
export { ReactComponent as IcSocialFacebook28 } from 'assets/28/social-facebook_28.svg';
export { ReactComponent as IcSocialFansly28 } from 'assets/28/social-fansly_28.svg';
export { ReactComponent as IcSocialInstagram28 } from 'assets/28/social-instagram_28.svg';
export { ReactComponent as IcSocialOnlyfans28 } from 'assets/28/social-onlyfans_28.svg';
export { ReactComponent as IcSocialTelegram28 } from 'assets/28/social-telegram_28.svg';
export { ReactComponent as IcSocialTiktok28 } from 'assets/28/social-tiktok_28.svg';
export { ReactComponent as IcSocialTwitter28 } from 'assets/28/social-twitter_28.svg';
export { ReactComponent as IcSocialVk28 } from 'assets/28/social-vk_28.svg';
export { ReactComponent as IcSocialDisable28 } from 'assets/28/social_disable_28.svg';
export { ReactComponent as IcSocialLink28 } from 'assets/28/social_link.svg';
export { ReactComponent as IcClock28 } from 'assets/28/clock_28.svg';
export { ReactComponent as IcPaperclip28 } from 'assets/28/paperclip_28.svg';
export { ReactComponent as IcMail28 } from 'assets/28/ic_mail28.svg';
export { ReactComponent as IcDice28 } from 'assets/28/dice_28.svg';
export { ReactComponent as IcCloud28 } from 'assets/28/cloud_28.svg';
export { ReactComponent as IcCloudUpload28 } from 'assets/28/cloud_upload_28.svg';
export { ReactComponent as IcHandler28 } from 'assets/28/handler_28.svg';
export { ReactComponent as IcCheck28 } from 'assets/28/check_28.svg';
export { ReactComponent as IcSort28 } from 'assets/28/sort_28.svg';
export { ReactComponent as IcDelete28 } from 'assets/28/delete_28.svg';
export { ReactComponent as IcFolderArrow28 } from 'assets/28/folder_arrow_28.svg';
export { ReactComponent as IcFolderCross28 } from 'assets/28/folder_cross_28.svg';
export { ReactComponent as IcBan28 } from 'assets/28/ban_28.svg';
export { ReactComponent as IcAds28 } from 'assets/28/ads_28.svg';
export { ReactComponent as IcCoin28 } from 'assets/28/coin_28.svg';
export { ReactComponent as IcSubscriptionMedia28 } from 'assets/28/subscription_media_28.svg';
export { ReactComponent as IcSubscriptionDirect28 } from 'assets/28/subscription_direct_28.svg';
export { ReactComponent as IcSubscriptionExtra28 } from 'assets/28/subscription_extra_28.svg';
export { ReactComponent as IcSubscriptionMore28 } from 'assets/28/subscription_more_28.svg';
export { ReactComponent as IcSuccessCheck28 } from 'assets/28/success_check.svg';
export { ReactComponent as IcDownload28 } from 'assets/28/download_28_v2.svg';
export { ReactComponent as IcMore28 } from 'assets/28/more_28.svg';
export { ReactComponent as IcLinkOld28 } from 'assets/28/link_28.svg';
export { ReactComponent as IcLink28 } from 'assets/28/link_28.svg';
export { ReactComponent as IcNewTab28 } from 'assets/28/newtab_28.svg';
export { ReactComponent as IcLoudSpeaker28 } from 'assets/28/loudspeaker_28.svg';
export { ReactComponent as IcUnpin28 } from 'assets/28/unpin_28.svg';
export { ReactComponent as IcCalendar28 } from 'assets/28/calendar_28.svg';
export { ReactComponent as IcOther28 } from 'assets/28/other_28.svg';
export { ReactComponent as IcWallet28 } from 'assets/28/wallet_28.svg';
export { ReactComponent as IcTranslate28 } from 'assets/28/translate_28.svg';
export { ReactComponent as IcBot28 } from 'assets/28/bot_28.svg';
export { ReactComponent as IcArrowCounterClockWise28 } from 'assets/28/arrow.counterclockwise_28.svg';
export { ReactComponent as IcArrowClockWise28 } from 'assets/28/arrow.clockwise_28.svg';
export { ReactComponent as IcLock28 } from 'assets/28/lock_28.svg';
export { ReactComponent as IcHelp28 } from 'assets/28/help_28.svg';
export { ReactComponent as IcUserQuestionmark28 } from 'assets/28/user_questionmark_28.svg';
export { ReactComponent as IcBankCard28 } from '$assets/28/bank_card_28.svg';
export { ReactComponent as IcAddStory28 } from 'assets/28/add_story_28.svg';
export { ReactComponent as IcPickaxe28 } from 'assets/28/pickaxe_28.svg';
export { ReactComponent as IcCards28 } from 'assets/28/cards_28.svg';

export { ReactComponent as IcBitcoin40 } from 'assets/40/bitcoin.svg';
export { ReactComponent as IcToncoin40 } from 'assets/40/toncoin.svg';
export { ReactComponent as IcUsdt40 } from 'assets/40/usdt.svg';
export { ReactComponent as IcLogo40 } from 'assets/40/logo.svg';

export { ReactComponent as IcPlay48 } from 'assets/48/ic-play-48.svg';
export { ReactComponent as IcPause48 } from 'assets/48/ic-pause-48.svg';
export { ReactComponent as IcSkipNext48 } from 'assets/48/skip_next_48.svg';
export { ReactComponent as IcSkipPrevious48 } from 'assets/48/skip_previous_48.svg';

export { ReactComponent as IcProfile56 } from 'assets/56/profile_56.svg';
export { ReactComponent as IcPost56 } from 'assets/56/post_56.svg';
export { ReactComponent as IcClip56 } from 'assets/56/clip_56.svg';
export { ReactComponent as IcTonkeeper56 } from 'assets/56/tonkeeper_56.svg';
export { ReactComponent as IcCard56 } from 'assets/56/card_56.svg';
export { ReactComponent as IcTon56 } from 'assets/56/ton_56.svg';
export { ReactComponent as IcCryptoCurrency56 } from 'assets/56/crypto_currency.svg';
export { ReactComponent as IcMastercard56 } from 'assets/56/mastercard.svg';
export { ReactComponent as IcVisa56 } from 'assets/56/visa.svg';
export { ReactComponent as IcMir56 } from 'assets/56/mir.svg';
export { ReactComponent as IcJcb56 } from 'assets/56/jcb.svg';
export { ReactComponent as IcDiscover56 } from 'assets/56/discover.svg';
export { ReactComponent as IcPix56 } from 'assets/56/pix-logo_56.svg';
export { ReactComponent as IcBoleto56 } from 'assets/56/boleto-logo_56.svg';
export { ReactComponent as IcSpei56 } from 'assets/56/spei-logo_56.svg';
export { ReactComponent as IcOxxo56 } from 'assets/56/oxxo-logo_56.svg';
export { ReactComponent as IcBankCard56 } from 'assets/56/bank_card_front_56.svg';

export { ReactComponent as IcSuccess72 } from 'assets/72/success_72.svg';
export { ReactComponent as IcFailed72 } from 'assets/72/failed_72.svg';
export { ReactComponent as IcWait72 } from 'assets/72/wait_72.svg';

export { ReactComponent as IcDiamond } from 'assets/diamond.svg';
export { ReactComponent as IcFire } from 'assets/fire.svg';
export { ReactComponent as IcWise } from 'assets/wise.svg';

export { ReactComponent as IcActionTypeMoney } from 'assets/actionType/money.svg';
export { ReactComponent as IcActionTypeLike } from 'assets/actionType/like.svg';
export { ReactComponent as IcActionTypeComment } from 'assets/actionType/comment.svg';
export { ReactComponent as IcActionTypeSponsor } from 'assets/actionType/sponsor.svg';
export { ReactComponent as IcActionTypeLogin } from 'assets/actionType/login.svg';
export { ReactComponent as IcActionTypeErotic } from 'assets/actionType/erotic.svg';

export const LottieData = {
  diamond: require('$assets/lottie/logo.json'),
};
